import * as Yup from "yup";

export const CreateWalletValidation = Yup.object().shape({
  Pin: Yup.string()
    .required("pin is required")
    .length(4, "Pin must be 4 numbers")
    .matches(/^\d+$/, "Pin must contain only digits"),
  confirmPin: Yup.string()
    .required()
    .oneOf([Yup.ref("Pin")], "Pin must match"),
  Bvn: Yup.string()
    .required("Please enter your Bvn")
    .matches(/^[0-9]+$/, "BVN must be only digits")
    .length(11, "BVN must be exactly 11 digits"),
    
  Dob: Yup.date().required("Please enter date of Birth"),
  Gender: Yup.string().required("Please enter your Gender"),
});

export type CreateWalletForm = Yup.InferType<typeof CreateWalletValidation>;
